// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!!!!! Do not modify this file or change will probably be lost !!!!!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import Validator from './Validator';
import MinMaxDTO from './MinMaxDTO';
import EntitySelectorDTO from './EntitySelectorDTO';

interface ThirdPartyCredentialTypeDTO extends EntitySelectorDTO { 
	id: number;
	name: string | null;
	displayOrder: number;
	enabledForSecondaryProgram: boolean;
	enabledForPostSecondaryProgram: boolean;
}

const ThirdPartyCredentialTypeDTO = {
    className: 'ThirdPartyCredentialTypeDTO',
    create: (initValues?: Partial<ThirdPartyCredentialTypeDTO> | Record<string, unknown> | null) => {
        return Object.assign(EntitySelectorDTO.create(),
        {
			id: 0,
			name: "",
			displayOrder: 0,
			enabledForSecondaryProgram: false,
			enabledForPostSecondaryProgram: false,
        },
        initValues);
    },
	id: 'id',
	name: 'name',
	displayOrder: 'displayOrder',
	enabledForSecondaryProgram: 'enabledForSecondaryProgram',
	enabledForPostSecondaryProgram: 'enabledForPostSecondaryProgram',
};

export default ThirdPartyCredentialTypeDTO;